export type BaseRteHeadingType = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'normal';

export const baseRteHeaderNumberByHeadingType = {
  h1: 1,
  h2: 2,
  h3: 3,
  h4: 4,
  h5: 5,
  normal: 0,
} satisfies Record<BaseRteHeadingType, number>;
